import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getDashboard, getDashboardYears } from "../controllers/dashboard";
import { useAuth } from "../components/auth/AuthProvider";
import AdminDashboard from "../components/dashboard/AdminDashboard";
import MemberDashboard from "../components/dashboard/MemberDashboard";
import { useNavigate } from "react-router-dom";
import Loading from "../components/loading/Loading";
import TeamCoordinatorDashboard from "../components/dashboard/TeamCoordinatorDashboard";
import YearSelector from "../components/common/YearSelector";
import useYearParam from "../hooks/useYearParam";

function Dashboard() {
  const { token } = useAuth();
  const [data, setData] = useState()
  const [cards, setCards] = useState([])
  const [role, setRole] = useState();
  const [title, setTitle] = useState('Dashboard');
  const [years, setYears] = useState([]);
  const navigate = useNavigate();
  const [selectedYear, onYearChange, currentYear] = useYearParam('year');

  useEffect(() => {
    document.title = 'FAMA - Dashboard';
    loadYearOptions();
  }, []);

  useEffect(() => {
    if (!isNaN(selectedYear)) {
      loadDashboard(selectedYear);
    }
  }, [selectedYear]);

  async function loadYearOptions() {
    try {
      const y = await getDashboardYears(token);
      if (y.length) {
        setYears(y);
      }
      else {
        setYears([currentYear]);
      }
    }
    catch (e) {
      setYears([currentYear]);
    }
  }

  async function loadDashboard(year) {
    try {
      let d = await getDashboard(token, year);
      console.log('cards', d);
      setCards(d.cards);
      if (d.title) {
        setTitle(d.title);
      }
      if (d.type === 'admin') {
        setRole('admin');
      }
      else if (d.type === 'member') {
        setRole('member');
      }
      else if (d.type === 'presidente-comunidad') {
        setRole('admin');
      }
      else if (d.type === 'team-coordinator') {
        setRole('team-coordinator');
      }
      setData(d);
    }
    catch (e) {
      console.log(e);
      setRole('member');
    }
  }

  if (!data) {
    return <Loading text="Cargando"></Loading>
  }
  else if (role === 'admin') {
    console.log('data', data);
    switch(data.level) {
      case 1: navigate(`/app/org/nacional?ciclo=${selectedYear}`); break;
      case 2: navigate(`/app/org/regiones/${data.org.region_id}?ciclo=${selectedYear}`); break;
      case 3: navigate(`/app/org/diocesis/${data.org.diocesis_id}?ciclo=${selectedYear}`); break;
      case 4: navigate(`/app/org/comunidades/${data.org.comunidad_id}?ciclo=${selectedYear}`); break;
      default: break;
    }
  }
  else if (role === 'admin' && cards.length) {
    return <AdminDashboard data={cards} title={title} />;
  }
  else if (role === 'team-coordinator') {
    return <>
      <Row className="mb-3">
        <Col><h1>Dashboard</h1></Col>
        <Col md={3} className="ms-auto">
          <YearSelector value={selectedYear} onChange={onYearChange} years={years} keyPrefix="dashboard-year" />
        </Col>
      </Row>
      <TeamCoordinatorDashboard cards={cards} data={data.fullData}  />
    </>;
  }
  else if (role === 'member') {
    return <>
      <Row className="mb-3">
        <Col><h1>Dashboard</h1></Col>
        <Col md={3} className="ms-auto">
          <YearSelector value={selectedYear} onChange={onYearChange} years={years} keyPrefix="dashboard-year" />
        </Col>
      </Row>
      <MemberDashboard data={cards} />
    </>;
  }
}

export default Dashboard;
